import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from './config.service';

import { Subject } from 'rxjs/Subject';

import { LoggingService } from './logging.service';

import { tokenNotExpired } from 'angular2-jwt';

import * as auth0 from 'auth0-js';

export interface UserMetadata {
    first_name: string;
    last_name: string;
}

export interface UserProfile {
    email: string;
    given_name: string;
    family_name: string;
}

@Injectable()
export class AuthService {
    // Store profile object in auth class
    userProfile: UserProfile;
    accessToken: string;

    onAuthentication: Subject<string> = new Subject<string>();

    webAuth: any;

    constructor(private router: Router
        , private config: ConfigService
        , private loggingService: LoggingService) {
        // Sets userProfile if it's already saved
        this.userProfile = JSON.parse(localStorage.getItem('profile'));
        this.accessToken = localStorage.getItem('access_token');

        this.webAuth = new auth0.WebAuth({
            clientID: this.config.Current.authClientId,
            domain: this.config.Current.authClientDomain,
            responseType: 'token',
            redirectUri: this.config.Current.authCallbackUrl
        });
    }

    public getProfileJson(): string {
        var result = '';

        if(this.userProfile) {
            result = JSON.stringify(this.userProfile, null, '\t');
        }
        
        return result;
    }

    public getProfileFirstName(): string {
        var result = '';
        
        if(this.userProfile)
        {
            result = this.userProfile.given_name;
        }

        return result;
    }

    public getProfileLastName(): string {
        var result = '';
        
        if(this.userProfile)
        {
            result = this.userProfile.family_name;
        }

        return result;
    }

    public getProfileEmail(): string {
        var result = '';

        if(this.userProfile)
        {
            result = this.userProfile.email;
        }

        return result;
    }

    public login() {
        localStorage.setItem('auth_redirect', window.location.pathname);
        this.webAuth.authorize({
            scope: 'openid profile email',
            audience: this.config.Current.authApiAudience,
            clientConnection: this.config.Current.authClientConnection,
            primaryConnection: this.config.Current.authPrimaryConnection,
            titleHtml: this.config.Current.titleHtml
        });
    }

    public handleAuthentication() {
        this.webAuth.parseHash((err, authResult) => {
            if (err) {
                if (this.loggingService) {
                    this.loggingService.logError(err, "auth.service.handleAuthentication.parseHash.OnError", {
                        "email": this.getProfileEmail()
                    });
                }

                console.error(err);
            } else if(authResult) {
                try {
                    this.setSession(authResult);

                    this.webAuth.client.userInfo(authResult.accessToken, (error, profile) => {
                        if (error) {
                            if (this.loggingService) {
                                this.loggingService.logError(error, "auth.service.handleAuthentication.userInfo.OnError", {
                                    "access_token": authResult.accessToken
                                });
                            }
                            // Handle error.
                            console.error(error);
                            return;
                        } else if (profile) {
                            localStorage.setItem('profile', JSON.stringify(profile));
                            this.userProfile = profile;
                        }
                    });

                    this.onAuthentication.next(this.accessToken);
                    const authRedirect = localStorage.getItem('auth_redirect');
                    if (authRedirect) {
                        localStorage.removeItem('auth_redirect');
                        this.router.navigate([authRedirect]);
                    }
                } catch (e) {
                    this.loggingService.logError(e, "auth.service.handleAuthentication.OnSuccess", {
                        "email": this.getProfileEmail()
                    });
                    console.error(e);
                }
            }
        });
    }

    private setSession(authResult): void {
        this.accessToken = authResult.accessToken;

        // Set the time that the access token will expire at
        const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('expires_at', expiresAt);
    }

    public isAuthenticated(): boolean {
        // Check whether the current time is past the
        // access token's expiry time
        const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        return new Date().getTime() < expiresAt;
    }

    public logout() {
        // Remove token and profile from localStorage
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('profile');
        this.userProfile = undefined;
        this.accessToken = undefined;
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/auth.service.ts